import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './PatientDashboard.css';

function PatientDashboard() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchSessions();
  }, []);

  const fetchSessions = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('http://localhost:5000/api/sessions', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setSessions(data.sessions);
      }
    } catch (error) {
      console.error('Error fetching sessions:', error);
    } finally {
      setLoading(false);
    }
  };

  const viewSession = (sessionId) => {
    navigate(`/session/${sessionId}`);
  };

  if (loading) {
    return <div className="patient-dashboard"><div className="loading">Loading...</div></div>;
  }

  return (
    <div className="patient-dashboard">
      <div className="dashboard-header">
        <h1>My Health Portal</h1>
        <p>View your consultation records and medical information</p>
      </div>

      <div className="dashboard-stats">
        <div className="stat-card">
          <div className="stat-icon">📋</div>
          <h3>{sessions.length}</h3>
          <p>Total Consultations</p>
        </div>
        <div className="stat-card">
          <div className="stat-icon">✅</div>
          <h3>{sessions.filter(s => s.status === 'completed' || s.status === 'approved').length}</h3>
          <p>Completed Visits</p>
        </div>
      </div>

      <div className="consent-notice">
        <div className="notice-icon">ℹ️</div>
        <div className="notice-content">
          <h3>Your Privacy is Protected</h3>
          <p>All consultations are recorded with your HIPAA-compliant consent. Your medical information is encrypted and secure.</p>
        </div>
      </div>

      <div className="sessions-section">
        <h2>My Consultation History</h2>
        <div className="sessions-list">
          {sessions.map(session => (
            <div key={session.id} className="session-card">
              <div className="session-header">
                <div className="session-date">
                  <span className="date-label">Date:</span>
                  <span className="date-value">{new Date(session.created_at).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}</span>
                </div>
                <span className={`status-badge ${session.status}`}>
                  {session.status === 'approved' ? 'Completed' : session.status}
                </span>
              </div>
              <div className="session-info">
                <p><strong>Session ID:</strong> {session.session_id}</p>
                {session.consent_given && (
                  <p className="consent-indicator">
                    <span className="consent-icon">🔒</span>
                    HIPAA Consent Provided
                  </p>
                )}
              </div>
              <button 
                onClick={() => viewSession(session.session_id)}
                className="btn-view-session"
              >
                View Conversation & Medical Info
              </button>
            </div>
          ))}

          {sessions.length === 0 && (
            <div className="no-sessions">
              <div className="no-sessions-icon">📅</div>
              <h3>No Consultations Yet</h3>
              <p>Your consultation history will appear here after your first visit.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PatientDashboard;
